import React from 'react';
import { useSubscription } from '../../SubscriptionContext';
import PlanCard from './PlanCard';
import ReservedCard from './ReservedCard';
import TeamCard from './TeamCard';
import MonthlyChart from './MonthlyChart';
import RecentErrorsCard from './RecentErrorsCard';
import RecentActivity from './RecentActivity';
import Announcements from './Announcements';
// dashboardSummary のみをインポート
import { dashboardSummary } from './mockData';

// (G-SIDE-COMMENT: この部分は変更ありません)
const getBillingPeriod = (subscriptionStartDateStr) => {
    if (!subscriptionStartDateStr) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const startDate = new Date(subscriptionStartDateStr);
    const anchorDay = startDate.getDate();

    const getAnchorDateFor = (year, month, day) => {
        const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
        const validDay = Math.min(day, lastDayOfMonth);
        return new Date(year, month, validDay);
    };

    const currentMonthAnchor = getAnchorDateFor(today.getFullYear(), today.getMonth(), anchorDay);

    let periodStart;
    if (today.getTime() >= currentMonthAnchor.getTime()) {
        periodStart = currentMonthAnchor;
    } else {
        let prevMonth = today.getMonth() - 1;
        let prevMonthYear = today.getFullYear();
        if (prevMonth < 0) {
            prevMonth = 11;
            prevMonthYear--;
        }
        periodStart = getAnchorDateFor(prevMonthYear, prevMonth, anchorDay);
    }

    let nextPeriodStartMonth = periodStart.getMonth() + 1;
    let nextPeriodStartYear = periodStart.getFullYear();
    if (nextPeriodStartMonth > 11) {
        nextPeriodStartMonth = 0;
        nextPeriodStartYear++;
    }
    
    const nextPeriodStartDate = getAnchorDateFor(nextPeriodStartYear, nextPeriodStartMonth, anchorDay);
    const periodEnd = new Date(nextPeriodStartDate);
    periodEnd.setDate(periodEnd.getDate() - 1);

    return { periodStart, periodEnd };
};

const formatDate = (date) => {
    if(!date) return '';
    return date.toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '/');
};

const Dashboard = () => {
  const { plan, invoiceCount, invoiceOverage, subscriptionStartDate, loading: subscriptionLoading } = useSubscription();

  const plans = {
    trial: { name: 'トライアルプラン', limit: Infinity },
    free: { name: 'フリープラン', limit: 5 },
    lite: { name: 'ライトプラン', limit: 30 },
    standard: { name: 'スタンダードプラン', limit: 100 },
    business: { name: 'ビジネスプラン', limit: 300 },
  };
  
  const billingPeriod = getBillingPeriod(subscriptionStartDate);

  const planData = {
    planName: plans[plan]?.name || 'N/A',
    invoiceCount: invoiceCount,
    invoiceOverage: invoiceOverage,
    periodStart: billingPeriod ? formatDate(billingPeriod.periodStart) : '--',
    periodEnd: billingPeriod ? formatDate(billingPeriod.periodEnd) : '--',
  };

  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      {/* 1段目: 概要カード */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {subscriptionLoading ? <div className="bg-white p-6 rounded-lg shadow-sm">読み込み中...</div> : <PlanCard data={planData} />}
        <ReservedCard data={dashboardSummary} />
        <TeamCard data={dashboardSummary} />
      </div>

      {/* 2段目: 月次処理状況グラフ */}
      <div className="mb-6">
        {/* dataプロパティを削除 */}
        <MonthlyChart />
      </div>

      {/* 3段目: エラー & アクティビティ */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <RecentErrorsCard />
        <RecentActivity /> 
      </div>

      {/* 4段目: お知らせ */}
      <div>
        <Announcements />
      </div>
    </div>
  );
};

export default Dashboard;
